/*
 * @LastEditors: Jacky
 * @LastEditTime: 2023-04-06 16:28:25
 * @FilePath: /mojito-xy-interface/src/components/Menu/arrow.tsx
 * Copyright (c) 2023 by Jacky, All Rights Reserved.
 */
export const Arrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9.00007L12 14.9883L18 9.00007"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
